export default __webpack_public_path__ + "static/doctor-graphic-cdfeb20a28c744bcf308552e6e20552d.svg";